import './Card.css'

const Card = ({ title, date, DeleteClick, SelectClick }) => {
  return (
    <div className="session-card" onClick={SelectClick}>
      <one-ux-text class="session-card-title">{title}</one-ux-text>
      <div className="session-card-divider">
        <one-ux-text class="session-card-date">{date}</one-ux-text>
        <one-ux-button
          class="session-card-button"
          label="Delete"
          purpose="defualt"
          implicit
          onClick={DeleteClick}></one-ux-button>
      </div>
    </div>
  )
}

export default Card
